/** @type {[string, string][]} */
export const USERS_FIELDS = [
  ["fields[]", "notifications_badges"],
  ["fields[]", "authorized_channels"],
  ["fields[]", "guest_notifications_badges"],
  ["fields[]", "customer_notifications_badges"],
  ["fields[]", "authorizations"],
];
